<template>
  <div class="main-container p-3">
    <KidHeader :profileId="profileId" :serialNumber="serialNumber" />

    <div class="back-home text-left mb-3">
      <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query: { profileId: this.profileId, serialNumber: serialNumber } })">
        <i class="fas fa-arrow-left"></i> <b>Back to Home</b>
      </a>
    </div>

    <div class="back-home text-right mb-1 pr-4">
        <button
          class="btn btn-primary px-4"
          :disabled="isDisabled"
          @click="openConfirmationModal()"
        >
          Set to default
          <span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
        </button>
    </div>
    <!-- Global Daily Limit -->
    <div class="card shadow-sm mb-2">
      <div class="card-body">
        <h6 class="card-title text-black">
          <i class="fas fa-clock text-primary me-2"></i> Device Daily Limit
        </h6>
        <small class="text-muted d-block mt-3">
          This limit disables all apps when usage exceeds the specified number of minutes.
        </small>
        <div class="d-flex align-items-center justify-content-center gap-2 mt-1">
          <button class="btn btn-light border" @click="decreaseLimit()">
            <ArrowLeftIcon />
          </button>
          <input
            type="text"
            class="form-control text-center font-weight-bold"
            :value="displayLimit"
            @input="handleLimitInput($event)"
            @blur="roundOF15"
            style="max-width: 80px;"
          />

          <button class="btn btn-light border" @click="increaseLimit()">
            <ArrowRightIcon />
          </button>
        </div>

        <!--<div class="text-center mt-1">
          <button
            class="btn btn-primary px-4 mt-2"
            :disabled="isDisabled"
            @click="updateGlobalSetting('GlobalDailyLimit')"
          >
            Save
            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
          </button>
        </div>-->
      </div>
    </div>

    <!-- Location Configuration -->
    <div class="card shadow-sm mb-1">
        <div class="card-body text-center">
            <h6 class="card-title text-black">
                <i class="fas fa-map-marker-alt text-primary me-2"></i> Configure Location Tracking
            </h6>
            <div class="mt-1 mb-1">
              <button
                class="btn btn-secondary px-4"
                :disabled="isDisabled"
                @click="sendLocationFcmCommand()"
                style="min-width: 180px;"  
              >
                Fetch Current Location
                <span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
              </button>
            </div>
            <small class="text-muted d-block mb-1">
                Set the time interval (in minutes) at which you want your child’s device location to be automatically updated and tracked. A shorter interval provides more frequent updates, while a longer interval may help conserve battery life.
            </small>

            <div class="d-flex align-items-center justify-content-center gap-2 mt-3">
              <button
                class="btn btn-light border"
                @click="decreaseLocationLimit()"
                :disabled="enableLocationTracking == false"
              >
                <ArrowLeftIcon />
              </button>

              <input
                type="text"
                class="form-control text-center font-weight-bold"
                :value="displayLocationLimit"
                @input="handleLocationInput($event)"
                @blur="roundOF15Location"
                style="max-width: 80px;"
                :disabled="enableLocationTracking == false"
              />

              <button
                class="btn btn-light border"
                @click="increaseLocationLimit()"
                :disabled="enableLocationTracking == false"
              >
                <ArrowRightIcon />
              </button>
            </div>


            <!-- Save Button -->
              <!--<button
              class="btn btn-primary px-4 mt-2"
              :disabled="isDisabled"
              @click="updateLocationSetting()"
            >
              Save
              <span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
            </button>-->
            <!-- Fetch Location Now Button separated and centered below -->
        </div>
    </div>

    <!-- Limit wingio child app -->
    <div class="card shadow-sm mb-2">
          <div class="card-body text-center">
              <h6 class="card-title text-black">
                <i class="fas fa-ban text-primary me-2"></i> Limit Wingio Child App
              </h6>
              <small class="text-muted d-block mt-3">
                When enabled, access to the Wingio Child app is limited and most features, including app requests, will be unavailable.
              </small>
              <label class="switch mt-1">
                  <input type="checkbox" v-model="limitChildApp" @change="updateLimitChildApp()">
                  <span class="slider round"></span>
              </label>
          </div>
    </div>

    <!-- Disable Adding/Deleting Account -->
    <div class="card shadow-sm mb-2">
          <div class="card-body text-center">
              <h6 class="card-title text-black">
                <i class="fas fa-user-lock text-primary me-2"></i> Disable Adding/Deleting Accounts
              </h6>
              <small class="text-muted d-block mt-3">
                Prevents adding or removing accounts on the child device to maintain administrative control and security.
              </small>
              <label class="switch mt-1">
                  <input type="checkbox" v-model="modify_accounts_disabled" @change="updateProfile()">
                  <span class="slider round"></span>
              </label>
          </div>
    </div>

    <!-- Turn on web monitoring -->
    <div class="card shadow-sm mb-2">
          <div class="card-body text-center">
              <h6 class="card-title text-black">
                <i class="fas fa-globe text-primary me-2"></i> Turn on Web Monitoring
              </h6>
              <small class="text-muted d-block mt-3">
                Activating systems that restrict access to certain types of online material.
              </small>
              <label class="switch mt-1">
                  <input type="checkbox" v-model="turnOnWebMonitoring" @change="updateTurnOnWebMonitoring()">
                  <span class="slider round"></span>
              </label>
          </div>
    </div>

    <!-- Enable notification sound -->
    <div class="card shadow-sm mb-2">
          <div class="card-body text-center">
              <h6 class="card-title text-black">
                <i class="fas fa-bell text-primary me-2"></i> Enable Notification Sound
              </h6>
              <small class="text-muted d-block mt-3">
                When enabled, your device will play a sound for each incoming notification.
              </small>
              <label class="switch mt-1">
                  <input type="checkbox" v-model="enableNotificationSound" @change="updateEnableNotificationSound()">
                  <span class="slider round"></span>
              </label>
          </div>
    </div>

    <!-- WINGIO Settings Access -->
    <div class="card shadow-sm settings-card">
      <div class="card-body">
        <h6 class="card-title text-black">
                <i class="fas fa-wrench text-primary me-2"></i> Settings Access Level
        </h6>

        <!-- Dropdown -->
        <select
          class="form-select modern-select"
          v-model="protectionStatus"
          @change="updateAllowFullAccess()"
        >
          <option :value="0">🟡 Medium — Partial Blocking</option>
          <option :value="1">🔴 Strict — Fully Blocked</option>
          <option :value="2">🟢 Relaxed — Full Access</option>
        </select>

        <!-- Info Box -->
        <div class="info-box mt-3" :class="infoClass">
          <i class="fas fa-info-circle me-2"></i>
          <span>{{ protectionInfo }}</span>
        </div>

      </div>
    </div>


      
    <!-- Ring / Stop Sound -->
    <div class="card shadow-sm mb-2">
        <div class="card-body text-center">
            <h6 class="card-title text-black">
              <i class="fas fa-volume-up text-primary me-2"></i> Ring This Device
            </h6>
            <small class="text-muted d-block mt-3">
            Sends a remote notification to play a sound — helpful for locating a misplaced phone.
            </small>

            <!-- Play / Stop Sound Button -->
            <button
            class="btn w-100 mt-2"
            :class="isPlaying ? 'btn-danger' : 'btn-outline-primary'"
            :disabled="isDisabled"
            @click="toggleSound"
            >
            <i :class="isPlaying ? 'fas fa-stop' : 'fas fa-play'"></i>
            {{ isPlaying ? 'Stop Sound' : 'Play Sound' }}
            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin ms-2"></i></span>
            </button>
        </div>
    </div>
    <!-- Kids Report Configuration -->
    <div class="card shadow-sm mb-1">
        <div class="card-body text-center">
            <h6 class="card-title text-black">
                <i class="fas fa-chart-bar text-primary me-2"></i> Kids Report Configuration
            </h6>
            <small class="text-muted d-block mb-1">
                Choose the frequency of the kids' reports that will be sent to you via email.
            </small>

            <!-- Report Frequency Radio Buttons -->
            <div class="mb-3">
                <div>
                  <div class="form-check form-check-inline">
                      <input 
                          type="radio" 
                          id="reportOff" 
                          name="reportFrequency" 
                          value="Off" 
                          v-model="reportFrequency" 
                          :disabled="isDisabled"
                          class="form-check-input"
                      >
                      <label class="form-check-label" for="reportOff">Off</label>
                  </div>
                  <div class="form-check form-check-inline">
                      <input 
                          type="radio" 
                          id="reportWeekly" 
                          name="reportFrequency" 
                          value="Weekly" 
                          v-model="reportFrequency" 
                          :disabled="isDisabled"
                          class="form-check-input"
                      >
                      <label class="form-check-label" for="reportWeekly">Weekly</label>
                  </div>
                  <div class="form-check form-check-inline">
                      <input 
                          type="radio" 
                          id="reportMonthly" 
                          name="reportFrequency" 
                          value="Monthly" 
                          v-model="reportFrequency" 
                          :disabled="isDisabled"
                          class="form-check-input"
                      >
                      <label class="form-check-label" for="reportMonthly">Monthly</label>
                  </div>
                </div>
            </div>

            <!-- Save Button -->
              <!--<button
                  class="btn btn-primary px-4"
                  :disabled="isDisabled"
                  @click="updateKidsReportFrequency()"
                >
                  Save
                  <span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
                </button>-->
        </div>
    </div>

    <!-- Reset Confirmation Modal -->
    <div class="modal fade" id="confirmationModal" tabindex="-1" role="dialog" aria-labelledby="confirmAccessModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-danger" id="confirmAccessModalLabel">Confirmation <i class="fas fa-exclamation-triangle"></i></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure you want to reset all settings? All settings will be restored to their default values.
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="resetGlobalSetting()">Yes Reset It</button>
            </div>
            </div>
        </div>
    </div>
    <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
    </div>
</template>

<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";
import ProfileService from "../../services/ProfileService";
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue'
import ArrowRightIcon from '@/components/icons/ArrowRightIcon.vue'

export default {
  name: 'Change Password',
  components: {
    KidHeader,
    KidFooter,
    ArrowLeftIcon,
    ArrowRightIcon
  },
  computed: {
    displayLimit() {
      // Show "No Limit" if 0 or empty
      if (!this.globalDailyLimit || this.globalDailyLimit === 0) {
        return "No Limit";
      }
      return this.globalDailyLimit;
    },
    displayLocationLimit() {
      if (!this.locationTrackingInterval || this.locationTrackingInterval === 0) {
          return "No Limit";
        }
        return this.locationTrackingInterval;
    },
    protectionInfo() {
      switch (Number(this.protectionStatus)) {
        case 0:
          return "The Settings app is accessible, but sensitive sections like App Info, Notifications, Accessibility, Wi-Fi, Location, VPN, Developer Options, and system permissions are blocked. This is the default recommended mode.";
        case 1:
          return "The entire Settings app is completely blocked. This provides maximum protection and prevents all system changes.";
        case 2:
          return "The Settings app is fully accessible. Only critical sections such as Accessibility, Wingio App Info, and Device Admin remain restricted for safety.";
      }
    },
    infoClass() {
      return {
        'info-medium': this.protectionStatus == 0,
        'info-strict': this.protectionStatus == 1,
        'info-relaxed': this.protectionStatus == 2,
      };
    }
  },

  data() {
    return {
        profileId: this.$route.query.profileId,
        serialNumber: this.$route.query.serialNumber,
        isDisabled: false,
        globalDailyLimit: "",
        isPlaying: false,
        currentAction: '',
        reportFrequency: 'Weekly', 
        deviceDetails: {
            batteryLevel: 87,
            batteryCheckedAt: '2025-07-15 09:30 AM',
            serialNumber: 'R52M80FB8JF',
            brand: 'Samsung',
            hardware: 'exynos9820',
            basebandVersion: 'G970FXXU9DTF1',
            manufacturer: 'Samsung',
            model: 'Galaxy S10e',
            androidVersion: '11',
            languageCode: 'en-US',
            imei: '123456789012345',
            wifiMac: '00:1A:2B:3C:4D:5E',
            networkOperator: 'T-Mobile',
            phoneNumber: '+1-202-555-0191',
            totalRam: '6 GB',
            totalStorage: '128 GB'
        },
        allowFullAccess: 0,
        locationTrackingInterval: 0,
        deviceId: null,
        turnOnWebMonitoring: false,
        enableNotificationSound: false,
        protectionStatus: 0,
        enableLocationTracking: true,
        limitChildApp: false,
        modify_accounts_disabled: true,
    }
  },
  methods: {
    async updateGlobalSetting(key) {
        if (this.globalDailyLimit % 15 != 0 ) {
            this.globalDailyLimit = 0;
            return this.$toast.error("Please enter time multiple of 15.");   
        }
        this.isDisabled = true;
        let data = { key: key, value: this.globalDailyLimit, serialNumber: this.serialNumber, profileId: this.profileId }
        await KidsService.updateGlobalSetting(data)
        .then((response) => {
            this.isDisabled = false;
            this.applyPolicy();
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async updateKidsReportFrequency() {
        this.isDisabled = true;
        let data = { kidsReportType: this.reportFrequency }
        await KidsService.updateKidsReportFrequency(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    resetGlobalSetting() {
        this.isDisabled = true;
        let data = { profileId: this.profileId, serialNumber: this.serialNumber }
        KidsService.resetGlobalSetting(data)
        .then((response) => {
            $('#confirmationModal').modal('hide');
            this.isDisabled = false;
            this.getGlobalSetting();
            this.getLocationSetting();
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    openConfirmationModal() {
      $('#confirmationModal').modal('show');
    },
    async applyPolicy() {
      let data = {
        profile_id: this.profileId,
        serialNumber: this.serialNumber
      };

      await ProfileService.applyPolicy(data)
        .then((response) => {
        })
        .catch((e) => {
          this.isDisabled = false;
          //this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getGlobalSetting() {
        let data = { key: "GlobalDailyLimit", serialNumber: this.serialNumber, profileId: this.profileId }
        await KidsService.getGlobalSetting(data)
        .then((response) => {
            if (response.data.data) {
                this.globalDailyLimit = parseInt(response.data.data.value)
            }
            this.modify_accounts_disabled = response.data?.profileDetail?.modify_accounts_disabled ?? true;
            this.allowFullAccess = response.data?.deviceData?.allowFullDeviceAccess ?? false;
            this.limitChildApp = response.data?.deviceData?.limitChildApp ?? false;
            const protectionEnabled = response.data?.deviceData?.protectionEnabled;
            this.protectionStatus =
              protectionEnabled == true
                ? "1"
                : protectionEnabled == false
                ? "0"
                : protectionEnabled; // already "0", "1", or "2"

            this.turnOnWebMonitoring = response.data?.deviceData?.turnOnWebMonitoring ?? false;
            this.enableNotificationSound = response.data?.deviceData?.enableNotificationSound ?? false;
            this.reportFrequency = response.data.kidsReportType
            this.isDisabled = false;
            
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    roundOF15() {
        if (this.globalDailyLimit > 0) {
            this.globalDailyLimit = Math.ceil(this.globalDailyLimit/15.0) * 15;
        }
    },
    decreaseLimit() {
        if (this.globalDailyLimit > 0) {
            this.globalDailyLimit = this.globalDailyLimit - 15
        }
        this.updateGlobalSetting('GlobalDailyLimit')
    },
    increaseLimit() {
        if (!this.globalDailyLimit) {
          this.globalDailyLimit = 0;
        }
        this.globalDailyLimit = (parseInt(this.globalDailyLimit) + 15)
        this.updateGlobalSetting('GlobalDailyLimit')
    },
    handleLimitInput(event) {
      const val = event.target.value.trim();

      if (val === "" || val.toLowerCase() === "no limit") {
        this.globalDailyLimit = 0;
      } else {
        const num = parseInt(val);
        if (!isNaN(num)) {
          this.globalDailyLimit = num;
        }
      }
      this.updateGlobalSetting('GlobalDailyLimit')
    },

    // === Location Tracking Interval Logic ===
    roundOF15Location() {
      if (this.locationTrackingInterval > 0) {
        this.locationTrackingInterval = Math.ceil(this.locationTrackingInterval / 15.0) * 15;
      }
    },
    decreaseLocationLimit() {
      if (this.locationTrackingInterval > 0) {
        this.locationTrackingInterval = this.locationTrackingInterval - 15;
      }
      if (this.locationTrackingInterval < 0) {
        this.locationTrackingInterval = 0;
      }
      this.updateLocationSetting()
    },
    increaseLocationLimit() {
      if (!this.locationTrackingInterval || this.locationTrackingInterval < 0) {
        this.locationTrackingInterval = 0;
      }
      this.locationTrackingInterval = parseInt(this.locationTrackingInterval) + 15;
      this.updateLocationSetting()
    },
    handleLocationInput(event) {
      const val = event.target.value.trim();

      if (val === "" || val.toLowerCase() === "no limit") {
        this.locationTrackingInterval = 0;
      } else {
        const num = parseInt(val);
        if (!isNaN(num)) {
          this.locationTrackingInterval = num;
        }
      }
      this.updateLocationSetting()
    },

    async getLocationSetting() {
        let data = {
            profile_id: this.profileId,
            serialNumber: this.serialNumber
        };
        await KidsService.getLocationSetting(data)
        .then((response) => {
            this.locationTrackingInterval = response.data.data?.locationTrackingInterval ?? 15
            this.deviceId = response.data.data?._id
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    updateLocationSetting() {
        this.isDisabled = true;
        let data = {
            _id: this.deviceId,
            enableLocationTracking: (this.locationTrackingInterval > 0) ? true : false,
            locationTrackingInterval: this.locationTrackingInterval
        };
        KidsService.updateDevice(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    updateTurnOnWebMonitoring() {
        this.isDisabled = true;
        let data = {
            _id: this.deviceId,
            turnOnWebMonitoring: this.turnOnWebMonitoring,
        };
        KidsService.updateDevice(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    updateEnableNotificationSound() {
        this.isDisabled = true;
        let data = {
            _id: this.deviceId,
            enableNotificationSound: this.enableNotificationSound
        };
        KidsService.updateDevice(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    updateLimitChildApp(){
        this.isDisabled = true;
        let data = {
            _id: this.deviceId,
            limitChildApp: this.limitChildApp
        };
        KidsService.updateDevice(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    updateProfile(){
        this.isDisabled = true;
        let data = {
            profileId: this.profileId,
            modify_accounts_disabled: this.modify_accounts_disabled
        };
        KidsService.updateProfile(data)
        .then((response) => {
            this.applyPolicy()
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async sendLocationFcmCommand() {
        this.isDisabled = true;
        let data = {
            title: "Send Location",
            message: "Send kid location",
            packageName: "",
            action: "send_location",
            serialNumber: this.serialNumber
        }
        await KidsService.sendFcmCommand(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success("The command has been sent successfully to the device.");
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    },
    
    async sendFcmCommand() {
        this.isDisabled = true;
        let data = {
            title: "Ring a Phone",
            message: "Ring a phone to help kid find his device.",
            packageName: "",
            action: "Ring a Phone",
            serialNumber: this.serialNumber
        }
        await KidsService.sendFcmCommand(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success("Rina a Phone command sent to device.");
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    },
    async toggleSound() {
        this.isDisabled = true;

        const action = this.isPlaying ? 'Stop Sound' : 'Ring a Phone';
        const data = {
            title: action,
            message: this.isPlaying ? 'Stop the ringing on the device.' : 'Ring a phone to help kid find the device.',
            action: action,
            packageName: '',
            serialNumber: this.serialNumber
        };

        try {
            await KidsService.sendFcmCommand(data);
            this.isPlaying = !this.isPlaying;
            this.$toast.success(`${action} command sent.`);
        } catch (err) {
            this.$toast.error(err.response?.data?.respones_msg || 'Failed to send command.');
        } finally {
            this.isDisabled = false;
        }
    },
    async sendDeviceCommand(action) {
        this.isDisabled = true;
        this.currentAction = action;
        const data = {
            type: action,
            serialNumber: this.serialNumber
        };

        try {
            await KidsService.sendDeviceCommand(data);
            this.$toast.success(`${action} command sent.`);
        } catch (err) {
            this.$toast.error(err.response?.data?.respones_msg || 'Failed to send command.');
        } finally {
            this.isDisabled = false;
        }
    },
    async updateAllowFullAccess() {
      let data = {
            profileId: this.profileId,
            kidsAppProtectionStatus: this.protectionStatus,
            serialNumber: this.serialNumber
        }
        await KidsService.updateKidsProtectionStatus(data)
        .then((response) => {
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    }
  },
  watch: {
    protectionStatus(val) {
      
    },
    reportFrequency() {
      this.updateKidsReportFrequency()
    }
  },

  beforeMount() {
    this.getGlobalSetting();
    this.getLocationSetting();
    if (this.$route.query.isPlaying) {
      this.toggleSound();
    } 
  },
}
</script>
<style scoped>
.card {
  border-radius: 10px;
}
input[type="text"] {
  font-size: 1.1rem;
}
.btn-icon-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-icon-flex i {
  margin-right: 8px;
}
input.form-control {
  font-size: 0.95rem;      /* slightly smaller text */
  padding: 0.25rem 0.3rem; /* tighter padding */
  text-overflow: ellipsis; /* avoids clipping visually */
}
.back-home {
  display: block;         /* Make it block level */
  width: 100%;            /* Full width */
  margin-bottom: 15px;
  font-size: 1rem;
}
</style>